package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.runtime.staticCompositionLocalOf

val LocalOpenPrivacyPolicy = staticCompositionLocalOf<() -> Unit> { {} }
